import React from 'react'
import { observer } from 'mobx-react'
import { Box, Slider, Typography, useTheme } from '@mui/material'
import { Icons } from '../../../utils/utilities'
import { useVideoPlayerStore } from '../../../store/video-player.store'

const VolumeControl = observer( () => {

    const store = useVideoPlayerStore()
    const { palette } = useTheme()

    return (
        <Box
            className="volume-container"
            display="flex"
            alignItems="center"
            position="relative"
            sx={{
                '&:hover .volume-slider-container': {
                    opacity: 1,
                    visibility: 'visible',
                    transform: 'translateX(-50%) translateY(0)'
                }
            }}
        >
            <Box
                className="volume-slider-container"
                position="absolute"
                left="50%"
                bottom="calc(100% + 10px)"
                padding="20px 10px 10px 10px"
                borderRadius="20px"
                bgcolor={palette.contentBg + '99'}
                sx={{
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                    opacity: 0,
                    visibility: 'hidden',
                    transform: 'translateX(-50%) translateY(10px)',
                    transition: 'all 0.2s ease-in-out',
                    pointerEvents: 'auto',
                    zIndex: 100000000000
                }}
            >
                <Slider
                    orientation="vertical"
                    value={store.volume}
                    step={0.1}
                    min={0}
                    max={1}
                    onChange={( e, newValue ) => store.handleVolumeSlide( e, newValue )}
                    sx={{
                        padding: '0 5px',
                        height: 100,
                        color: '#fff',
                        '& .MuiSlider-thumb': {
                            width: 12,
                            height: 12,
                            '&:hover, &.Mui-focusVisible': {
                                boxShadow: '0px 0px 0px 8px rgba(255, 255, 255, 0.16)'
                            }
                        },
                        '& .MuiSlider-track': {
                            border: 'none'
                        },
                        '& .MuiSlider-rail': {
                            opacity: 0.5,
                            backgroundColor: '#bfbfbf'
                        }
                    }}
                />
            </Box>
            {store.volume === 0 ? (
                <Box component="button" disabled={store.controllerOptions.volume === false} onClick={store.toggleMute} className="control-btn">
                    {Icons.small.VolumeOffIcon}
                </Box>
            ) : store.volume > 0.5 ? (
                <button disabled={store.controllerOptions.volume === false} onClick={store.toggleMute} className="control-btn">
                    {Icons.small.VolumeUpIcon}
                </button>
            ) : (
                <button disabled={store.controllerOptions.volume === false} onClick={store.toggleMute} className="control-btn">
                    {Icons.small.VolumeDownIcon}
                </button>
            )}
            {store.controllerOptions.volume === false && store.config.defaults.volume === 0 && (
                <Typography fontSize="10px" color="GrayText">
                    DISABLED
                </Typography>
            )}
        </Box>
    )
} )

export default VolumeControl